const RequestFaqchat = async (input, filtermessages, userId, mode, loginInfo, setMessages) => {
    // ApiHandler.search(newMessage.text, filterMessages, 'test_user', mode, loginInfo, setMessages)
    try {
        // loginInfoから設定を抽出
        const filter = loginInfo?.faqapi?.faqchat?.filter || '';
  
        let prompt;
        if (loginInfo?.prompt?.faqchat?.prompt) {
            prompt = loginInfo.prompt.faqchat.prompt;
        } else {
            prompt = `あなたはマニュアルに対して質問に答えるRAGアシスタントです。
#ルール:
- ユーザーの【質問】に対して【テキスト】【過去履歴】を参考にして回答してください。
- 【過去の履歴】からユーザーの意図を理解してください。
- 【テキスト】【過去履歴】にないことは答えないでください。
- わかりやすく手順を箇条書きにしてください。`;
        }


        // メッセージ履歴処理
        // 最初のメッセージを削除
        filtermessages.shift();
        // 最新のユーザーメッセージを抽出
        const histmessages = filtermessages.slice(-1);

        // メッセージからHTMLタグと画像マーカーを削除し、imagemessageと結合
        const repInput = histmessages
            .filter(msg => msg.sender === "user")
            .map((msg) => {
                // HTMLタグと画像マーカーを削除
                const cleanText = msg.text.replace(/<[^>]*>|\[画像情報\]/g, '');
                // imagemessageが存在する場合は結合
                const combinedText = msg.imagemessage
                    ? `${msg.imagemessage} ${cleanText}`
                    : cleanText;
                
                return { content: combinedText };
        });

        const query = {
            search: repInput[0].content,
            top: 5,
            filter: '',
            select: "sub_category,category,title,content,answer,site_name,URL,site_icon,model,update_at,tag",
            vectorQueries: [
                { 
                    kind: "text",
                    text: repInput[0].content,
                    k: 5,
                    fields: "embedding"
                }
            ],
        queryType: "semantic",
        captions: "extractive",
        answers: "extractive|count-3",
        semanticConfiguration: "cosmosdb03-semantic-configuration",
        queryLanguage: "ja-JP"
        } 



    const header = {
        'Content-Type': 'application/json',
        'api-key': "XXXXXXXXXX",
    };

    const requestBody = {
        api:process.env.REACT_APP_FAQ_URL,
        header:header,
        query: query,
        filter:filter,
        userId: userId,
        mode:mode,
        prompt:prompt,
        inputs:repInput[0].content
    };
    
    try {

        const response = await fetch(`${process.env.REACT_APP_CROSPRO_URL}?code=${process.env.REACT_APP_CROSPRO_KEY}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
        });

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";
        let resmessage = "";

        while (true) {

            const { done, value } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split("\n");
            buffer = lines.pop();

            for (let line of lines) {
            line = line.trim();
            if (!line.startsWith("data:")) continue;
            const jsonStr = line.replace(/^data:\s*/, "");
            
            if (jsonStr === "[DONE]") continue;

            try {
                const dataObj = JSON.parse(jsonStr);
                const delta = dataObj.choices[0].delta.content;
                resmessage += delta; // ここで逐次 finalText に追加
                if (delta) {
                setMessages((prev) => {
                    const newMessages = [...prev];
                    if (newMessages.length === 0 || newMessages[newMessages.length - 1].sender !== "faqchat"
                    ) { 
                        newMessages.push({ id: crypto.randomUUID(),sender: "faqchat", text: delta , mode: 'faqchat', timestamp: Date.now()});
                    } else {
                        newMessages[newMessages.length - 1].text += delta;
                    }
                    return newMessages;
                });
                }
            } catch (e) {
                console.error("JSON parse error:", e, jsonStr);
            }
            }
        }

        return resmessage

    } catch (error) {
        console.log('API_応答データerror:', error);
        return `申し訳ありません。<br>問合せエラーが発生しました。`
    }
        

        // TODO: API設定の構築
        // TODO: ストリーミングレスポンスの処理
        
        return ""; // 一時的な戻り値

    } catch (error) {
        console.log('API_応答データerror:', error);
        return `申し訳ありません。<br>問合せエラーが発生しました。`;
    }

};

// 他のファイルで使えるようにエクスポート
export default RequestFaqchat;
